import React from "react";
import { CharacterSheet, Pericia, Especializacao } from "../data/characterSchema";

interface Props {
  character: CharacterSheet;
  onChange: (character: CharacterSheet) => void;
}

export const Pericias: React.FC<Props> = ({ character, onChange }) => {
  const updatePericia = (index: number, field: keyof Pericia, value: any) => {
    const newPericias = [...character.pericias];
    newPericias[index] = { ...newPericias[index], [field]: value };
    onChange({ ...character, pericias: newPericias });
  };

  const addEspecializacao = (periciaIndex: number) => {
    const newPericias = [...character.pericias];
    newPericias[periciaIndex].especializacoes.push({ nome: "", nivel: 1 });
    onChange({ ...character, pericias: newPericias });
  };

  const removeEspecializacao = (periciaIndex: number, espIndex: number) => {
    const newPericias = [...character.pericias];
    newPericias[periciaIndex].especializacoes = newPericias[periciaIndex].especializacoes.filter(
      (_, i) => i !== espIndex
    );
    onChange({ ...character, pericias: newPericias });
  };

  const updateEspecializacao = (
    periciaIndex: number,
    espIndex: number,
    field: keyof Especializacao,
    value: any
  ) => {
    const newPericias = [...character.pericias];
    newPericias[periciaIndex].especializacoes[espIndex] = {
      ...newPericias[periciaIndex].especializacoes[espIndex],
      [field]: value,
    };
    onChange({ ...character, pericias: newPericias });
  };

  const categorias = [
    {
      nome: "Combate",
      pericias: character.pericias.filter((p) =>
        ["Combate Corpo a Corpo", "Combate à Distância", "Combate Desarmado"].includes(p.nome)
      ),
    },
    {
      nome: "Técnica",
      pericias: character.pericias.filter((p) =>
        ["Alquimia", "Matrizes", "Mecânica"].includes(p.nome)
      ),
    },
    {
      nome: "Social",
      pericias: character.pericias.filter((p) =>
        ["Persuasão", "Liderança", "Negociação"].includes(p.nome)
      ),
    },
    {
      nome: "Ocultismo",
      pericias: character.pericias.filter((p) =>
        ["Meditação", "Conhecimento Oculto", "Rituais"].includes(p.nome)
      ),
    },
  ];

  return (
    <div className="section">
      <h2>Perícias</h2>
      {categorias.map((categoria) => (
        <div key={categoria.nome} className="pericia-categoria">
          <h3>{categoria.nome}</h3>
          <table>
            <thead>
              <tr>
                <th>Perícia</th>
                <th>Atributo</th>
                <th>Nível</th>
                <th>Especializações</th>
              </tr>
            </thead>
            <tbody>
              {categoria.pericias.map((pericia, pIndex) => {
                const globalIndex = character.pericias.findIndex((p) => p.nome === pericia.nome);
                return (
                  <tr key={pericia.nome}>
                    <td><strong>{pericia.nome}</strong></td>
                    <td>{pericia.atributo}</td>
                    <td>
                      <input
                        type="number"
                        value={pericia.nivel}
                        onChange={(e) => updatePericia(globalIndex, "nivel", parseInt(e.target.value) || 0)}
                        min="0"
                      />
                    </td>
                    <td>
                      <div className="especializacoes">
                        {pericia.especializacoes.map((esp, espIndex) => (
                          <div key={espIndex} className="especializacao-item">
                            <input
                              type="text"
                              value={esp.nome}
                              onChange={(e) =>
                                updateEspecializacao(globalIndex, espIndex, "nome", e.target.value)
                              }
                              placeholder="Nome"
                            />
                            <input
                              type="number"
                              value={esp.nivel}
                              onChange={(e) =>
                                updateEspecializacao(globalIndex, espIndex, "nivel", parseInt(e.target.value) || 1)
                              }
                              min="1"
                              placeholder="Nível"
                            />
                            <button
                              type="button"
                              onClick={() => removeEspecializacao(globalIndex, espIndex)}
                              className="btn-remove-small"
                            >
                              ×
                            </button>
                          </div>
                        ))}
                        <button
                          type="button"
                          onClick={() => addEspecializacao(globalIndex)}
                          className="btn-add-small"
                        >
                          + Especialização
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};
